export const ChannelsQueryKeys = {
  POPULAR_CHANNELS: (userId?: string) => ['popular-channels', userId],
};
